import { createNavigation } from 'next-intl/navigation';

export const localePrefix = 'never';
export const locales = ['ee', 'fi', 'lt', 'lv', 'pl', 'ru-lv', 'ru-ee'];

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation({
    locales,
    localePrefix,
  });
